<ng-container *transloco="let t">
  @if (!loading()) {
    <div class="flex flex-col gap-4">
      <IFormField>
        <label iLabel>{{ t("common.name") }}</label>
        <input
          iInput
          [(ngModel)]="name"
          placeholder="{{ t('new-account-group-popup.give_name_placeholder') }}"
          [maxLength]="200"
        />
      </IFormField>

      <div class="flex justify-end gap-2">
        <button iButton variant="secondary" (click)="modalRef.close()">
          {{ t("common.cancel") }}
        </button>
        <button iButton [disabled]="name().trim().length === 0" (click)="create()">
          {{ t("common.create") }}
        </button>
      </div>
    </div>
  }
  <ISpinner [display]="loading()" />
</ng-container>
